import { createSelector } from 'reselect';
import DailyRouteLeadingCountColumns from '../../containers/DailyRouteLeadingCountColumns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.DAILY_ROUTE_LEADING_COUNT_SUMMARY.isLoading;
export const getData = TableDefinitions.DAILY_ROUTE_LEADING_COUNT_SUMMARY.getDataFunction();
export const getColumns = createSelector(getData, DailyRouteLeadingCountColumns);
